import { createDeferredI18n } from "#/shared/composables/useI18n";

import fallbackMessages from "#/shared/i18n/frontend.directory_pdf_export.json";

export const { i18n, ready: whenI18nReady } = createDeferredI18n({ key: "directory_pdf_export", fallbackMessages });

/**
 * Translates a directory-PDF-export string. Keys are relative to
 * `frontend.directory_pdf_export`, which the i18n endpoint serves as the message
 * root, and resolve per client through that client's own locale files.
 *
 * @param {String} key
 * @param {Object} [values] - Interpolation values.
 * @returns {String}
 */
export function t(key, values) {
  return i18n.global.t(key, values);
}
